(function () {
  function removeVideoControls() {
    if (window.innerWidth <= 768) {
      document.querySelectorAll('video').forEach(function (video) {
        video.removeAttribute('controls');
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
      });
    }
  }

  document.addEventListener('DOMContentLoaded', removeVideoControls);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var videos = node.tagName === 'VIDEO' ? [node] : Array.from(node.querySelectorAll('video'));
        videos.forEach(function (video) {
          if (window.innerWidth <= 768) {
            video.removeAttribute('controls');
            video.setAttribute('muted', '');
            video.setAttribute('playsinline', '');
            video.setAttribute('autoplay', '');
            video.setAttribute('loop', '');
          }
        });
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();